<template>
  <b-card
    title="مدیریت زائرکارت"
  >
    <b-row>
      <b-col
        class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-col md="3">
                <b-form-group
                  label="جستجو"
                  label-for="Title"
                >
                  <b-form-input
                    v-model="filterOptions.Title"
                    placeholder="نام، نام خانوادگی، تماس یا مقصد"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="وضعیت"
                  label-for="Status"
                >
                  <v-select
                    v-model="filterOptions.Status"
                    :options="enums('ZaerCardStatus')"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              class="font-weight-bold"
              @click="showModal(data.item)"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(FullName)="data">
            {{ data.item.FirstName }} {{ data.item.LastName }}
          </template>

          <template #cell(Phone)="data">
            <a
              :href="`tel:${data.value}`"
              style="color: #6e6b7b;"
            >{{ data.value }}</a>
          </template>

          <template #cell(CreatedAt)="data">
            {{ data.value | date('jYYYY-jMM-jDD') }}
            <br>
            {{ data.value | date('HH:mm') }}
          </template>

          <template #cell(Status)="data">
            <b-badge
              :variant="enums('ZaerCardStatus', 'value', data.value, 'badge')"
            >
              {{ enums('ZaerCardStatus', 'value', data.value, 'text') }}
            </b-badge>
          </template>

          <template #cell(actions)="data">
            <div class="action-color d-flex">
              <b-link
                class="mr-1"
                @click="showModal(data.item)"
              >
                <feather-icon
                  :id="`zaer-row-${data.item.Id}-edit-icon`"
                  icon="EditIcon"
                  size="16"
                />
              </b-link>
              <b-link
                class="text-danger"
                @click="remove(data.item.Id)"
              >
                <feather-icon
                  :id="`zaer-row-${data.item.Id}-del-icon`"
                  icon="Trash2Icon"
                  size="16"
                />
              </b-link>
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>

    <zaer-card-details
      v-if="isShow"
      v-model="isShow"
      :request="row"
      @save="save"
    />

  </b-card>
</template>

<script>

import ZaerCardDetails from '@/views/menu/zaercard/zaercarddetails.vue'

export default {
  name: 'ZaerCard',
  components: {
    ZaerCardDetails,
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
        Status: null,
      },
      isShow: false,
      row: {},
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'FullName',
          label: 'نام و نام خانوادگی',
        },
        {
          key: 'Phone',
          label: 'شماره تماس',
        },
        {
          key: 'Destination',
          label: 'مقصد سفر',
        },
        {
          key: 'TripType',
          label: 'نوع سفر',
        },
        {
          key: 'CreatedAt',
          label: 'تاریخ',
        },
        {
          key: 'Status',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.zaercard.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    showModal(row) {
      this.row = JSON.parse(JSON.stringify(row))
      this.isShow = true
    },
    save(updatedRow) {
      this.$http.post(this.$api.zaercard.update, { Id: updatedRow.Id, Status: updatedRow.Status })
        .then(() => {
          this.update()
        }).catch(() => {
          this.isShow = true
        })
    },
    remove(id) {
      this.removeRow(this.$api.zaercard.remove, 'Id', id)
    },
  },
}
</script>

<style>
.col-width-89{
  width: 89px;
}

.action-color a{
  color: #6e6b7b !important;
}
</style>
